<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong class="card-title mb-3">{{'Profit Growth Analysis'}}</strong>
        </div>
        <div class="col-md-1">
          <download :tableId="tabs[actTab]['title']" :fileName="tabs[actTab]['title']+'-data'"></download>
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <vue-tabs v-model="selTab" direction="horizontal" @tab-change="getTabData">
        <v-tab :title="alg.name" v-for="(alg, index) in tabs" v-bind:key="index">
          <!-- <v-tab title="Growth Summary"> -->
          <div class="row mb-15"></div>
          <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <input
                type="text"
                v-model="searchParams.companyname"
                class="form-control"
                name="companyname"
                placeholder="Search by company"                
              >
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <!-- @keyup="search"<input type="text" v-model="searchParams.sectorname" class="form-control" name="sector" placeholder="Search by Sector"/> -->
              <select class="form-control" name="sector" v-model="searchParams.sectorname">
                <option value>Select Sector</option>
                <option
                  v-for="(sec, index) in sectorData"
                  :value="sec.sect_name"
                  v-bind:key="sec.sect_code+index"
                >{{sec.sect_name}}</option>
              </select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="row">
              <div class="col-md-2">
                <div class="form-group" style="margin-top: 3px;">
                  <button type="button" class="btn btn-sm btn-primary" @click="search">
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group" style="margin-top: 3px;">
                  <button type="button" class="btn btn-sm btn-success" @click="reset">
                    <i class="fa fa-refresh"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
          <div class="row mb-15">
            <div class="col-md-12">
              <div class="table-responsive" v-dragscroll="true">
                <table :id="alg.title" class="table table-bordered fonts11">
                  <thead>
                    <tr>
                      <!-- <th>Sr.</th> -->
                      <th :key="'tcol'+index" v-for="(col, index) in  tableColumns">{{col.name}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr :key="'trow'+ind" v-for="(row, ind) in  rawData">
                      <!-- <td>{{(ind+1)}}</td> -->
                      <td :key="'tcol'+index" v-for="(col, index) in  tableColumns">
                        <span v-if="pname !== 'competativeness'">
                          <span
                            v-if="col.title === 'co_code' || 
                          col.title === 'companyname' || 
                          col.title === 'sectorname' || 
                          col.title === 'number_of_time_negative_profit_growth' || 
                          col.title === 'number_of_time_negative_sales_growth' || 
                          col.title === 'number_of_time_sign_change_profit_growth' || 
                          col.title === 'number_of_time_sign_change_sales_growth' || 
                          col.title === 'consistency_analysis'"
                          >{{row[col.title]}}</span>
                          <span
                            v-else-if="col.title === 'latest_trends_more_than_or_equal_five_yes'"
                          >{{(row[col.title]==='T')? 'Turnaround Possiblity': 'No Turnaround Possiblity'}}</span>
                          <span
                            v-else
                          >{{(row[col.title]=== 1)? 'Yes': (row[col.title]===0)? 'No': '-'}}</span>
                        </span>
                        <span v-else>
                          <span v-if="col.title !== 'conclusion'">
                            <span
                              v-if="checkInArray([ 'co_code', 'companyname', 'sectorname'], col.title)"
                            >{{row[col.title]}}</span>
                            <span v-else>{{getFixed(row[col.title])}}</span>
                          </span>
                          <span
                            v-if="col.title === 'conclusion'"
                          >{{getCompetitiveString(tableColumns[index-1].title,ind)}}</span>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="row mt-15" v-if="rawData && rawData.length && totalPages>1">
                <div class="col-md-7"></div>
                <div class="col-md-5">
                  <div class="pull-right">
                    <ul v-if="totalPages != 1" class="pagination">
                      <li :class="{disabled:prevDisabled}" class="page-item">
                        <a class="page-link" @click.prevent="goToPage(1)" href="#">{{'&lt;&lt;'}}</a>
                      </li>
                      <li :class="{disabled:prevDisabled}" class="page-item">
                        <a class="page-link" @click.prevent="prev()" href="#">{{'&lt;'}}</a>
                      </li>
                      <li
                        v-for="page in pages"
                        v-bind:key="page"
                        class="page-item"
                        :class="(current_page == page)? 'active':''"
                      >
                        <a class="page-link" @click.prevent="goToPage(page)" href="#">{{page}}</a>
                      </li>
                      <li :class="{disabled:nextDisabled}" class="page-item">
                        <a class="page-link" href="#" @click.prevent="next()">{{'&gt;'}}</a>
                      </li>
                      <li :class="{disabled:nextDisabled}" class="page-item">
                        <a
                          class="page-link"
                          href="#"
                          @click.prevent="goToPage(totalPages)"
                        >{{'&gt;&gt;'}}</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-tab>
      </vue-tabs>
    </div>
  </div>
  <!-- </card> -->
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import { VueTabs, VTab } from "vue-nav-tabs";
import "vue-nav-tabs/themes/vue-tabs.scss";
export default {
  // props: ["company"],
  components: { VueTabs, VTab },
  mixins: [commonMixins],
  created() {
    this.getRawData();
    if(!this.sectorData.length){
      this.getSectorData();
    }
  },
  methods: {
    getRawData() {
      this.rawData = [];
      this.tableColumns = [];
      let myself = this;
      const data = { name: this.pname, pageid: this.current_page, companyname: this.searchParams.companyname, sectorname: this.searchParams.sectorname }
      http.post(
        this.rawDataApi,
        data,
        (error, response) => {
          console.log(response);
          if (response.data.length > 0) {
            this.rawData = response.data;
            this.totalPages = response.total_pages ? response.total_pages : 1;
            let i = 8;
            let page = this.current_page - 2;
            if (page <= 0) page = 1;
            this.pages = [];
            while (i) {
              this.pages.push(parseInt(page));
              if (this.totalPages <= page) break;
              page++;
              i--;
            }
            console.log(response);
            if (this.pname !== "competativeness") {
              var tableCols = Object.keys(this.rawData[0]);
              tableCols.forEach((val, key) => {
                this.tableColumns.push({
                  title: val,
                  name: this.getCustomLabel(val)
                    ? this.getCustomLabel(val)
                    : this.getLabel(val),
                  isNumeric: typeof val === "number" ? true : false,
                  sort_order:
                    val === "co_code"
                      ? 1
                      : val === "companyname"
                      ? 2
                      : val === "sectorname"
                      ? 3
                      : 5,
                  isLink: val === "companyname" ? 1 : 0
                });
              });
            } else {
              this.getCompetitiveFields();
            }
          }
          this.tableColumns = this.sorted_fields_asc(
            this.tableColumns,
            "sort_order"
          );
          console.log("Table Columns", this.tableColumns);
        }
      );
    },
    getTabData(tabIndex, newTab, oldTab) {
      console.log(tabIndex, newTab.title, oldTab);
      this.selTab = newTab.title;
      this.actTab = tabIndex;
      this.pname = this.tabs[this.actTab].pname;
      this.getRawData();
    },
    getCompetitiveFields() {
      this.tableColumns = this.competitiveFields;
    },
    prev() {
      this.pageToLoad = this.current_page - 1;
      this.fillTable();
    },
    goToPage(page) {
      this.pageToLoad = page;
      this.fillTable();
    },
    next() {
      console.log(this.$route.query);
      this.pageToLoad = this.current_page + 1;
      this.prevDisabled = 0;
      this.fillTable();
    },
    fillTable() {
      this.page = this.pageToLoad;
      if (this.pageToLoad == this.totalPages) {
        this.nextDisabled = 1;
      } else {
        this.nextDisabled = 0;
      }
      if (this.pageToLoad == 1) {
        this.prevDisabled = 1;
      } else {
        this.prevDisabled = 0;
      }
      this.current_page = this.pageToLoad;
      this.getRawData();
    },
    getCompetitiveString(title, ind) {
      let label = "";
      this.growthAnalysisTerms.forEach((val, key) => {
        if (this.rawData[ind][title + "_" + val.title]) {
          label = val.name;
        }
      });
      return label;
    },
    getSectorData() {
      let _this = this;
      // this.axios.get("getSectorList", {}, {headers: {Authorization: 'Bearer ' + localStorage.getItem('token')}}).then((response) => {
      http.get("getSectorList", {}, function(error, response) {
        console.log("Sector Data", response);
        _this.sectorData = response;
      });
    },
    search() {
      console.log(this.searchParams);
      if (
        this.searchParams.companyname.length > 2 ||
        this.searchParams.sectorname != ""
      ) {
        this.getRawData();
      }
      if (
        this.searchParams.companyname.length == 0 &&
        this.searchParams.sectorname == ""
      ) {
        console.log("Reset");
        this.reset();
      } else{
        console.log("Not Reset");
      }
    },
    reset() {
      this.searchParams = { companyname: "", sectorname: "" };
      this.pageToLoad = 1;
      this.current_page = 1;
      this.getRawData();
    },
  },
  data() {
    return {
      tabs: [
        {
          title: "growth-summary",
          name: "Growth Summary",
          pname: "profit_sales"
        },
        {
          title: "competative-advantage",
          name: "Competitive Advantage",
          pname: "competative"
        },
        {
          title: "consistancy-analysis",
          name: "Consistancy Analysis",
          pname: "consistancy"
        },
        {
          title: "cyclical-analysis",
          name: "Cyclical Analysis",
          pname: "cyclical"
        },
        { title: "latest-trends", name: "Latest Trends", pname: "latest" },
        {
          title: "competativeness",
          name: "Competitiveness",
          pname: "competativeness"
        }
      ],      
      searchParams: { companyname: "", sectorname: "" },
      sectorData: [],
      rawDataApi: "growthAnalysis",
      rawData: [],
      pname: "profit_sales",
      tableColumns: [],
      tableRows: [],
      selTab: "",
      actTab: 0,
      competitiveFields: [
        {title: "co_code", name: "Co Code"},
        {title: "companyname", name: "Company"},
        {title: "sectorname", name: "Sector"},
        {title: "marketCapitalization_latest", name: "Market Cap (Latest)"},
        {title: "avg_ebitDA_per_sales", name: "EBITDA per Sales"},
        {title: "conclusion", name: "EBITDA per Sales Conclusion"},
        {title: "avg_capex_per_net_profit", name: "Capex per Net Profit"},
        {title: "conclusion", name: "Capex per Net Profit Conclusion"},
        {title: "avg_net_profit_per_sales", name: "Net Profit per Sales"},
        {title: "conclusion", name: "Net Profit per Sales Conclusion"},
        {title: "avg_interest_per_sales", name: "Interest per Sales"},
        {title: "conclusion", name: "Interest per Sales Conclusion"},
        {title: "percentage_variation_selling_n_administration_per_ns", name: "Selling and Administration per NS"},
        {title: "conclusion", name: "Selling and Administration per NS Conclusion"},
        {title: "avg_research_development_costs_per_sales", name: "Research and Development costs per Sales"},
        {title: "conclusion", name: "Research and Development costs per Sales Conclusion"},
        {title: "avg_depreciation_per_sales", name: "Depreciaion per Sales"},
        {title: "conclusion", name: "Depreciaion per Sales Conclusion"},
        {title: "number_of_time_sign_change_eps", name: "No. of time change in EPS"},
        {title: "conclusion", name: "No. of time change in EPS Conclusion"},
        {title: "number_of_time_sign_change_cash_eps", name: "No. of time change in Cash EPS"},
        {title: "conclusion", name: "No. of time change in Cash EPS Conclusion"}
      ],
      growthAnalysisTerms: [
        {title: "high_competative_advantage", name: "High Competitive Adv."},
        {title: "some_competative_advantage", name: "Some Competitive Adv."},
        {title: "highly_competative", name: "Highly Competitive"},
        {title: "fiercely_competative", name: "Fiercely Competitive"},
      ],
      page: 1,
      current_page: 1,
      pageToLoad: 1,
      totalPages: 1,
      prevDisabled: 1,
      nextDisabled: 0,
      pages: []
    };
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/company/growthAnalysis.vue